/* eslint-disable eqeqeq */
import React from "react";
import { Modal } from "flowbite-react";
import ThreeDotsLoader from "./ThreeDotsLoader";
function AreYouSure({ openModal, onClose, submitAccess, submitting, access }) {
  return (
    <div>
      <Modal
        dismissible
        show={openModal === "dismissible"}
        size="lg"
        onClose={onClose}
      >
        <Modal.Body className="p-0">
          <div className="p-4 pb-8 pt-10">
            <h3 className="text-center font-bold text-[26px]">Are You Sure?</h3>
            <p className="text-center font-bold text-[20px] text-[#7D7D7D]">
              Do You really want To change Access from {access?.from} to{" "}
              {access?.to}
            </p>
            <div className="pt-4 flex justify-between px-4">
              <button
                type="button"
                className="flex w-[180px] items-center text-center justify-center py-2 px-[20px] rounded-[20px] font-semibold text-black hover:text-[white] border border-[black] hover:border-[#54BD3A] hover:bg-[#54BD3A]"
                onClick={onClose}
              >
                Cancel
              </button>
              <button
                type="button"
                className="flex w-[180px] items-center text-center justify-center py-2 px-[20px] rounded-[20px] font-semibold text-[white] border border-[#ED400A] bg-[#ED400A]"
                onClick={() => {
                  submitAccess();
                }}
              >
                {submitting ? (
                  <div className="flex items-center">
                    <div>Submitting</div>
                    <div>
                      <ThreeDotsLoader />
                    </div>
                  </div>
                ) : (
                  <>Submit</>
                )}
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default AreYouSure;
